import { get } from 'helpers/api';
import types from './types';

// author
export const getAuthor = slug => {
  return (dispatch, getState) => {
    const {
      author: { isAuthorLoaded, isAuthorLoading },
    } = getState();
    if (!isAuthorLoading) {
      return dispatch(getNewAuthor(slug));
    } else {
      return false;
    }
  };
};

export const getNewAuthor = slug => {
  return dispatch =>
    get(`/user/${slug}`, {
      data: { slug },
      before: () => dispatch(getAuthorStart()),
      success: author => dispatch(getAuthorSuccess(author)),
    });
};

const getAuthorStart = () => {
  return {
    type: types.GET_AUTHOR_START,
  };
};

const getAuthorSuccess = author => {
  return {
    type: types.GET_AUTHOR_SUCCESS,
    author,
  };
};



// WEBPACK FOOTER //
// state/author/actions.js